import useInteractiveWidgetSubmit from '../../../hooks/useInteractiveWidgetSubmit';
import {PALETTE_UI_TOOL_NAME} from '../../../domain/campaignToolCatalog';
import PaletteSelector from '../PaletteSelector';

export default function PaletteIntegration({
  isReadOnly = false,
  toolCallId = null,
  paletteData = null,
}) {
  const {handleSubmit: handleComplete, isPending} = useInteractiveWidgetSubmit(
    PALETTE_UI_TOOL_NAME,
    toolCallId,
    'PARAMETRIZACAO_COMPLETA: paleta',
  );

  return (
    <PaletteSelector
      isReadOnly={isReadOnly || isPending}
      initialData={paletteData}
      onComplete={isReadOnly || isPending ? undefined : handleComplete}
    />
  );
}
